// Original supplied artwork; CSS crops only the surrounding background/payoff.
export default function DadLogo({ className = "", ...props }) {
  return <span className={`dad-logo ${className}`} {...props}><img src="/assets/dad-logo-official.png" alt="DAD® Company Brain — L'intelligenza che fa crescere la tua azienda" width="1672" height="941" /></span>;
}
